import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { CoreService } from '../../services/core.service';
import * as NavigationActions from '../actions/navigation.actions';

@Injectable()
export class NavigationEffects {
  loadNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NavigationActions.loadNavigation),
      mergeMap((action) =>
        from(this.coreService.getNavigation()).pipe(
          map((routes) => NavigationActions.loadNavigationSuccess({ routes })),
          catchError((error) =>
            of(NavigationActions.loadNavigationFailure({ error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private coreService: CoreService,
  ) { }
}
